































import { Component, Vue } from 'vue-property-decorator';

import { Alert } from '@/components/Alert';
import { Button } from '@/components/Button';

import { Ledgerer } from '../../../../src';

@Component({ components: { Alert, Button }, name: 'Ledger' })
export default class extends Vue {
	// --- data

	public loading: boolean = false;
	public error: any = null;
	public done: any = null;

	public Ledgerer: typeof Ledgerer = Ledgerer;

	// --- methods

	// --- methods

	public async beforeOpen({ params = {} }: { params: any }): Promise<void> {
		try {
			this.loading = true;

			await Ledgerer.connect();

			this.loading = false;

			this.done = params?.done;
		} catch {
			//
		}
	}

	public async beforeClose(): Promise<void> {
		//
	}

	public async connect(): Promise<void> {
		this.error = null;

		this.loading = true;

		if (await Ledgerer.connect(true)) {
			this.$modal.hide('ledger');

			this?.done?.(true);
		} else {
			this.error = 'No device selected';
		}

		this.loading = false;
	}

	public async disconnect(): Promise<void> {
		this.error = null;

		this.loading = true;

		await Ledgerer.disconnect();

		this?.done?.(false);

		this.loading = false;
	}
}
